import FileDownload from '@/components/FileDownload';
import TitleLayout from '@/components/Layout/TitleLayout';
import ButtonWithLoading from '@oncolens/oncolens-ui/lib/components/FormControls/ButtonWithLoading';
import DatePicker from '@oncolens/oncolens-ui/lib/components/FormControls/DatePicker';
import Combobox, {
  ComboboxItem,
} from '@oncolens/oncolens-ui/lib/components/FormControls/Combobox/Combobox';
import clsx from 'clsx';
import React, { useState } from 'react';
import { getReportData } from '../api/qip';
import { useOrganizationData } from '@/features/organizations/organization.hooks';

export const BehaviorConfigReport = () => {
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const orgData = useOrganizationData();
  const [organization, setOrganization] = useState<ComboboxItem | any | null>(null);
  const startDateInvalid = !!startDate && !!endDate && startDate > endDate;

  return (
    <TitleLayout title="QIP Report">
      <div className="grid max-w-xl grid-cols-2 gap-3">
        <div className="col-span-2">
          <Combobox
            id="organization"
            htmlName="organization"
            label="Organization"
            data={orgData}
            value={organization}
            onChange={(item) => setOrganization(item)}
            useAutocomplete
          />
        </div>
        <DatePicker
          id="startDate"
          htmlName="startDate"
          selected={startDate}
          setSelected={setStartDate}
          label="Start Date"
          error={clsx(startDateInvalid && 'Start Date must be before End Date')}
        />
        <DatePicker
          id="endDate"
          htmlName="endDate"
          selected={endDate}
          setSelected={setEndDate}
          label="End Date"
        />
      </div>
      <FileDownload getData={getReportData} args={[organization?.value, startDate, endDate]}>
        {({ onClick, loading }) => (
          <ButtonWithLoading
            onClick={onClick}
            loading={loading}
            buttonColor="blue"
            className="max-w-[150px] mt-3"
            disabled={loading || !startDate || !endDate || !organization || startDateInvalid}>
            <span className="whitespace-nowrap">Run Report</span>
          </ButtonWithLoading>
        )}
      </FileDownload>
    </TitleLayout>
  );
};
